import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=2e31f9d8&scoped=true"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"
import style0 from "./Intro.vue?vue&type=style&index=0&id=2e31f9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e31f9d8",
  null
  
)

export default component.exports